// extracted by mini-css-extract-plugin
export var actionButton = "_kw-0";
export var fileInput = "_kw-2";
export var paperclip = "_kw-1";